<template>
  <Drawer
    v-model:visible="internalVisible"
    :position="position"
    :modal="modal"
    :style="{ width: width, maxWidth: '90vw' }"
    :pt="{
      header: '',
      content: 'flex flex-col h-full min-h-0 overflow-hidden',
      footer: 'sticky bottom-0 z-10',
      pcCloseButton: { root: { class: 'hidden' } },
    }"
    :data-test-id="testId"
    class="h-full relative"
    @hide="emit('close')"
  >
    <template #header>
      <slot name="header">
        <div class="flex items-center justify-between w-full px-4 py-3 border-b border-surface-200 dark:border-surface-700">
          <span class="text-base font-semibold text-surface-900 dark:text-surface-0">
            {{ title }}
          </span>
          <button
            type="button"
            class="inline-flex items-center justify-center w-8 h-8 rounded hover:bg-surface-100 dark:hover:bg-surface-700 text-surface-500 dark:text-surface-400 transition-colors"
            data-test-id="details-sidebar-close"
            @click="close"
          >
            <XMarkIcon class="w-5 h-5" />
          </button>
        </div>
      </slot>
    </template>

    <slot />

    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </Drawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Drawer } from 'primevue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

interface Props {
  visible: boolean
  width?: string
  position?: 'left' | 'right'
  modal?: boolean
  title?: string
  testId?: string
}

const props = withDefaults(defineProps<Props>(), {
  width: '560px',
  position: 'right',
  modal: false,
  title: '',
  testId: undefined,
})

const emit = defineEmits<{
  'update:visible': [value: boolean]
  'close': []
}>()

const internalVisible = computed({
  get: () => props.visible,
  set: (value: boolean) => emit('update:visible', value),
})

function close() {
  emit('update:visible', false)
}
</script>

<style scoped></style>
